;(() => {
  class PlaceMap {
    constructor() {
      this.container = $(".place-map--container")
      this.canvas = this.container.find(".place-map")
      const json = $("#markers").text()
      this.markers = JSON.parse(json)
    }

    load(options = {}) {
      const map = new API.Map(this.canvas[0], options)
      const bounds = new API.LatLngBounds()
      const infowindow = new API.InfoWindow()

      this.markers.forEach((markerData) => {
        const marker = new API.Marker({
          map,
          title: markerData[2],
          animation: API.Animation.DROP,
          position: { lat: markerData[0], lng: markerData[1] },
        })

        API.event.addListener(marker, "click", () => {
          infowindow.setContent(markerData[3])
          infowindow.open(map, marker)
          return false
        })

        bounds.extend(marker.position)
      })

      if (this.markers.length === 1) {
        map.setZoom(10)
        map.setCenter({ lat: this.markers[0][0], lng: this.markers[0][1] })
      } else {
        map.fitBounds(bounds)
      }
    }
  }

  let API = null

  const defaultOptions = {
    scrollwheel: false,
    streetViewControl: false,
  }

  // locations page (/locations)
  window.placesMapReady = () => {
    API = window.google.maps
    const map = new PlaceMap()
    map.container.show()
    map.load(defaultOptions)
  }
})()
